export class SmsMessageFilter {
  RecipientPhonenumber: string;

  constructor() {
    this.RecipientPhonenumber = null;
  }
}
